(function () {
'use strict';
var $23945faf07dff779$var$getStoredTheme = function() {
    return localStorage.getItem('theme');
};
var $23945faf07dff779$var$setStoredTheme = function(theme) {
    return localStorage.setItem('theme', theme);
};
var $23945faf07dff779$var$removeStoredTheme = function() {
    return localStorage.removeItem('theme');
};
// Override the server-rendered color-scheme media queries so that a manually
// selected theme can take precedence over the operating system preference.
var $23945faf07dff779$var$setPictureColorScheme = function(theme) {
    document.querySelectorAll('picture source[data-picture-color-scheme]').forEach(function(source) {
        source.media = source.dataset.pictureColorScheme === theme ? 'all' : 'not all';
    });
};
// Gets the theme from storage or the media query
var $23945faf07dff779$var$getPreferredTheme = function() {
    var storedTheme = $23945faf07dff779$var$getStoredTheme();
    if (storedTheme) return storedTheme;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};
// Set the data attribute
var $23945faf07dff779$var$setTheme = function(theme) {
    document.documentElement.setAttribute('data-color-scheme', theme);
    $23945faf07dff779$var$setPictureColorScheme(theme);
    // Dispatch a custom event that we can use to react to the theme change
    var event = new CustomEvent('colorModeChange', {
        detail: theme
    });
    document.dispatchEvent(event);
};
/**
 * Event Listeners
 */ // React to changes to the prefers-color-scheme media query
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function() {
    $23945faf07dff779$var$removeStoredTheme();
    $23945faf07dff779$var$setTheme($23945faf07dff779$var$getPreferredTheme());
});
// React to changes to the toggle
window.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-color-scheme-toggle]').forEach(function(toggle) {
        toggle.addEventListener('click', function() {
            var targetTheme = document.documentElement.getAttribute('data-color-scheme') === 'dark' ? 'light' : 'dark';
            $23945faf07dff779$var$setStoredTheme(targetTheme);
            $23945faf07dff779$var$setTheme(targetTheme);
        });
    });
});
// Fallback in case the critical inline script did not run.
if (!document.documentElement.getAttribute('data-color-scheme')) $23945faf07dff779$var$setTheme($23945faf07dff779$var$getPreferredTheme());
$23945faf07dff779$var$setPictureColorScheme(document.documentElement.getAttribute('data-color-scheme') || $23945faf07dff779$var$getPreferredTheme());
window.getColorScheme = function() {
    return document.documentElement.getAttribute('data-color-scheme');
};

})();
//# sourceMappingURL=darkmode.min.js.map
